import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import {trackTimingEvent} from 'middleware/analytics'
import {
  setIsAcquiringGeoCoordinates,
  setLocalizationConfig
} from 'modules/meta/slice'
import {setUserLocationSearchType} from 'modules/search/slice'
import {LocationSearchType} from 'modules/search/types'
import {
  GeolocationSource,
  getHasGeolocationPermission,
  getPosition
} from 'utils/geolocation'

import {Entity, Team} from '@vio/core/src/analytics/types/Events'
import {
  persistGeolocation,
  persistGeolocationSource
} from '@vio/core/src/utils/geolocation'
import {logAndCaptureErrorMessage} from '@vio/core/src/utils/logging/errorHandlers'

export const useSetDeviceGeolocationSearchParams = () => {
  const dispatch = useDispatch()

  const setDeviceGeolocationSearchParams = useCallback(async () => {
    try {
      const hasPermission = await getHasGeolocationPermission()
      if (hasPermission) {
        dispatch(setIsAcquiringGeoCoordinates(true))
      }
      const {coords} = await getPosition()

      const {latitude, longitude} = coords
      const geolocation = {lat: latitude, lon: longitude}
      persistGeolocation(geolocation)
      persistGeolocationSource(GeolocationSource.Device)
      dispatch(
        setLocalizationConfig({
          geolocation
        })
      )

      dispatch(setUserLocationSearchType(LocationSearchType.UserLocation))
      dispatch(setIsAcquiringGeoCoordinates(false))
      trackTimingEvent(
        dispatch,
        'GeolocationCoordinates',
        'GeolocationCoordinates-start',
        Entity.GeolocationCoordinatesFetch,
        Team.Default,
        true
      )
    } catch (error) {
      dispatch(setIsAcquiringGeoCoordinates(false))
      logAndCaptureErrorMessage(
        `Error fetching geolocation info - ${error?.message}`,
        {
          level: 'warning'
        }
      )
    }
  }, [dispatch])

  return {
    setDeviceGeolocationSearchParams
  }
}
